import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Clean URL hash
        window.history.replaceState(null, "", "/admin");
        if (user?.is_admin) {
          toast.success(`Welcome, ${user.name || user.email}`);
          navigate("/admin", { replace: true, state: { user } });
        } else {
          toast.error("This account is not authorized for the admin dashboard.");
          navigate("/login", { replace: true });
        }
      } catch (err) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-4 border-primary/20 border-t-primary animate-spin mx-auto" />
        <p className="mt-5 text-ink-700">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
